var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5H4.16667H17.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8307 5.00033V16.667C15.8307 17.109 15.6551 17.5329 15.3426 17.8455C15.03 18.1581 14.6061 18.3337 14.1641 18.3337H5.83073C5.3887 18.3337 4.96478 18.1581 4.65222 17.8455C4.33966 17.5329 4.16406 17.109 4.16406 16.667V5.00033M6.66406 5.00033V3.33366C6.66406 2.89163 6.83966 2.46771 7.15222 2.15515C7.46478 1.84259 7.8887 1.66699 8.33073 1.66699H11.6641C12.1061 1.66699 12.53 1.84259 12.8426 2.15515C13.1551 2.46771 13.3307 2.89163 13.3307 3.33366V5.00033",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWhite);
export default __webpack_public_path__ + "static/media/delete_white.5d825734c56c50e4545bec40370062ae.svg";
export { ForwardRef as ReactComponent };